let CONSULTAS_BACKEND_URL;
if (process.env.VUE_APP_BACKEND_URL)
    CONSULTAS_BACKEND_URL = process.env.VUE_APP_BACKEND_URL;
else
    CONSULTAS_BACKEND_URL = 'http://localhost:9000/rfi/';

let sitekey;
if (process.env.VUE_APP_RECAPTCHA_SITEKEY)
    sitekey = process.env.VUE_APP_RECAPTCHA_SITEKEY;
else
    sitekey = '6Lf9KQYgAAAAAKbRjQjA8rTxDrugBnTC5vKmhsJ8';


export default {
    CONSULTAS_BACKEND_URL: CONSULTAS_BACKEND_URL,
    CONSULTAS_SUBPATH: process.env.VUE_APP_CONSULTAS_SUBPATH,
    AUTH_URL: '/login',
    SITEKEY: sitekey
}
